// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  height: 100%;
  width: 16em;
  background-color: #8f003c;
  gap: 0.1em;
  overflow-y: scroll;
  padding-block: 0.5em;
  scrollbar-width: none;
}
.sidebar-collapse, .sidebar-collapse:focus, .sidebar-collapse:hover, .sidebar-collapse:active {
  height: 0.5em;
  outline: none;
  box-shadow: none !important;
  border: none;
  background-color: #8f003c;
}
.sidebar-container {
  width: 100%;
}
.sidebar-file-item-container {
  justify-content: space-between !important;
}
.sidebar-file-item {
  display: flex;
}
.sidebar-item {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  color: #fff;
  padding-inline: 1em;
  height: 3em;
  cursor: pointer;
  text-decoration: none !important;
}
.sidebar-item-logo {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #a53363;
  width: 1.5em;
  height: 1.5em;
  border-radius: 0.6em;
}
.sidebar-item-name {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 1em;
}
.sidebar-item:hover {
  color: #fff;
  background-color: #c4145d;
}
.sidebar-item--nohover {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  color: #fff;
  padding-inline: 1em;
  height: 3em;
  cursor: pointer;
  text-decoration: none !important;
}
.sidebar-item--nohover-logo {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #a53363;
  width: 1.5em;
  height: 1.5em;
  border-radius: 0.6em;
}
.sidebar-item--nohover-name {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 1em;
}
.sidebar-submenu {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;
  color: #fff;
  padding-inline: 1em;
  cursor: pointer;
  padding-left: 3.5em;
  font-weight: 300;
  text-decoration: none;
}
.sidebar-submenu:hover {
  background-color: #c4145d;
}
.sidebar-submenu-item {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  color: #fff;
  height: 2.7em;
  padding-inline: 1em;
  cursor: pointer;
  display: block;
  color: #fff;
  line-height: 2.5em;
}
.sidebar-submenu-item-file {
  display: flex;
}
.sidebar-submenu-item:focus, .sidebar-submenu-item:hover {
  color: #fff;
}

@media screen and (max-width: 1700px) {
  .external-icon {
    display: none;
  }
  .sidebar {
    width: 4em;
  }
  .sidebar-item-name {
    display: none;
  }
  .sidebar-submenu-container {
    display: none;
    border-radius: 0 0.5em 0.5em 0;
  }
  .sidebar-submenu:hover:first-child {
    border-radius: 0 0.5em 0 0;
  }
  .sidebar-submenu:hover:last-child {
    border-radius: 0 0 0.5em 0;
  }
  .menu-on-hover:hover {
    position: relative;
  }
  .menu-on-hover:hover > .sidebar-submenu-container {
    display: block;
    position: fixed;
    z-index: 20;
    overflow: scroll;
    margin-inline: 0;
    width: 11em;
    border-radius: 0 0.5em 0.5em 0;
    background-color: #8f003c;
  }
  .menu-on-hover:hover > .sidebar-submenu-container > a {
    padding: 0;
  }
  .menu-on-hover:hover > #content {
    left: 4em;
    top: 11.5em;
  }
  .menu-on-hover:hover > #products {
    left: 4em;
    top: 15em;
  }
  .menu-on-hover:hover > #members {
    left: 4em;
    top: 18em;
  }
}
::-webkit-scrollbar {
  width: 0px;
}

.sidebar-selected {
  background-color: #c4145d;
}`, "",{"version":3,"sources":["webpack://./src/components/sidebar/sidebar.scss","webpack://./src/sass/globals/mixins.scss","webpack://./src/sass/globals/globals.scss"],"names":[],"mappings":"AAGA;ECIC,aAAA;EACA,sBAAA;EACA,2BDLoB;ECMpB,uBDNgC;EAChC,YAAA;EACA,WAAA;EACA,yBEPU;EFQV,UAAA;EACA,kBAAA;EACA,oBAAA;EACA,qBAAA;AACD;AACC;EAIC,aAAA;EACA,aAAA;EACA,2BAAA;EACA,YAAA;EACA,yBErBS;AFmBX;AAKC;EACC,WAAA;AAHF;AAMC;EACC,yCAAA;AAJF;AAOC;EACC,aAAA;AALF;AAQC;ECnCA,aAAA;EACA,2BDmCe;EClCf,mBDkC2B;EAC1B,WAAA;EACA,WE/BW;EFgCX,mBAAA;EACA,WAAA;EACA,eAAA;EACA,gCAAA;AAJF;AAME;EC5CD,aAAA;EACA,uBD4CgB;EC3ChB,mBD2CwB;EACtB,yBE7CkB;EF8ClB,YAAA;EACA,aAAA;EACA,oBAAA;AAFH;AAKE;ECpDD,aAAA;EACA,uBDoDgB;ECnDhB,mBDmDwB;EACtB,gBAAA;AADH;AAIE;EACC,WEnDU;EFoDV,yBE3DsB;AFyDzB;AAMC;EC/DA,aAAA;EACA,2BD+De;EC9Df,mBD8D2B;EAC1B,WAAA;EACA,WE3DW;EF4DX,mBAAA;EACA,WAAA;EACA,eAAA;EACA,gCAAA;AAFF;AAIE;ECxED,aAAA;EACA,uBDwEgB;ECvEhB,mBDuEwB;EACtB,yBEzEkB;EF0ElB,YAAA;EACA,aAAA;EACA,oBAAA;AAAH;AAGE;EChFD,aAAA;EACA,uBDgFgB;EC/EhB,mBD+EwB;EACtB,gBAAA;AACH;AAGC;ECtFA,aAAA;EACA,2BDsFe;ECrFf,mBDqF2B;EAC1B,eAAA;EACA,WAAA;EACA,WEnFW;EFoFX,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,qBAAA;AACF;AACE;EACC,yBElGsB;AFmGzB;AAEE;ECrGD,aAAA;EACA,2BDqGgB;ECpGhB,mBDoG4B;EAC1B,WAAA;EACA,WEjGU;EFkGV,aAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;EACA,WE1GK;EF2GL,kBAAA;AAEH;AAAG;EACC,aAAA;AAEJ;AACG;EAEC,WEnHI;AFmHR;;AAMA;EACC;IACC,aAAA;EAHA;EAMD;IACC,UAAA;EAJA;EAOD;IACC,aAAA;EALA;EAQD;IACC,aAAA;IACA,8BAAA;EANA;EASD;IACC,0BAAA;EAPA;EAUD;IACC,0BAAA;EARA;EAWD;IACC,kBAAA;EATA;EAYD;IACC,cAAA;IACA,eAAA;IACA,WAAA;IACA,gBAAA;IACA,gBAAA;IACA,WAAA;IACA,8BAAA;IACA,yBEnKS;EFyJT;EAYA;IACC,UAAA;EAVD;EAcD;IACC,SAAA;IACA,WAAA;EAZA;EAeD;IACC,SAAA;IACA,SAAA;EAbA;EAgBD;IACC,SAAA;IACA,SAAA;EAdA;AACF;AAkBA;EACC,UAAA;AAhBD;;AAmBA;EACC,yBE/LwB;AF+KzB","sourcesContent":["@import '../../sass/globals/globals.scss';\n@import '../../sass/globals/mixins.scss';\n\n.sidebar {\n\t@include flexColumn(flex-start, flex-start);\n\theight: 100%;\n\twidth: 16em;\n\tbackground-color: $dark-red;\n\tgap: .1em;\n\toverflow-y: scroll;\n\tpadding-block: 0.5em;\n\tscrollbar-width: none;\n\n\t&-collapse,\n\t&-collapse:focus,\n\t&-collapse:hover,\n\t&-collapse:active {\n\t\theight: 0.5em;\n\t\toutline: none;\n\t\tbox-shadow: none !important;\n\t\tborder: none;\n\t\tbackground-color: $dark-red;\n\t}\n\n\t&-container {\n\t\twidth: 100%;\n\t}\n\n\t&-file-item-container {\n\t\tjustify-content: space-between !important;\n\t}\n\n\t&-file-item {\n\t\tdisplay: flex;\n\t}\n\n\t&-item {\n\t\t@include flex(flex-start, center);\n\t\twidth: 100%;\n\t\tcolor: $font-color;\n\t\tpadding-inline: 1em;\n\t\theight: 3em;\n\t\tcursor: pointer;\n\t\ttext-decoration: none !important;\n\n\t\t&-logo {\n\t\t\t@include flex(center, center);\n\t\t\tbackground-color: $sidebar-logo-color;\n\t\t\twidth: 1.5em;\n\t\t\theight: 1.5em;\n\t\t\tborder-radius: 0.6em;\n\t\t}\n\n\t\t&-name {\n\t\t\t@include flex(center, center);\n\t\t\tmargin-left: 1em;\n\t\t}\n\n\t\t&:hover {\n\t\t\tcolor: $font-color;\n\t\t\tbackground-color: $sidebar-selected-color;\n\t\t}\n\t}\n\n\t&-item--nohover {\n\t\t@include flex(flex-start, center);\n\t\twidth: 100%;\n\t\tcolor: $font-color;\n\t\tpadding-inline: 1em;\n\t\theight: 3em;\n\t\tcursor: pointer;\n\t\ttext-decoration: none !important;\n\n\t\t&-logo {\n\t\t\t@include flex(center, center);\n\t\t\tbackground-color: $sidebar-logo-color;\n\t\t\twidth: 1.5em;\n\t\t\theight: 1.5em;\n\t\t\tborder-radius: 0.6em;\n\t\t}\n\n\t\t&-name {\n\t\t\t@include flex(center, center);\n\t\t\tmargin-left: 1em;\n\t\t}\n\t}\n\n\t&-submenu {\n\t\t@include flex(flex-start, center);\n\t\tflex-wrap: wrap;\n\t\twidth: 100%;\n\t\tcolor: $font-color;\n\t\tpadding-inline: 1em;\n\t\tcursor: pointer;\n\t\tpadding-left: 3.5em;\n\t\tfont-weight: 300;\n\t\ttext-decoration: none;\n\n\t\t&:hover {\n\t\t\tbackground-color: $sidebar-selected-color;\n\t\t}\n\n\t\t&-item {\n\t\t\t@include flex(flex-start, center);\n\t\t\twidth: 100%;\n\t\t\tcolor: $font-color;\n\t\t\theight: 2.7em;\n\t\t\tpadding-inline: 1em;\n\t\t\tcursor: pointer;\n\t\t\tdisplay: block;\n\t\t\tcolor: $white;\n\t\t\tline-height: 2.5em;\n\t\t\t\n\t\t\t&-file {\n\t\t\t\tdisplay: flex;\n\t\t\t}\n\n\t\t\t&:focus,\n\t\t\t&:hover {\n\t\t\t\tcolor: $white;\n\t\t\t}\n\t\t}\n\t}\n}\n\n@media screen and (max-width: 1700px) {\n\t.external-icon{\n\t\tdisplay: none;\n\t}\n\n\t.sidebar {\n\t\twidth: 4em;\n\t}\n\n\t.sidebar-item-name {\n\t\tdisplay: none;\n\t}\n\n\t.sidebar-submenu-container {\n\t\tdisplay: none;\n\t\tborder-radius: 0 0.5em 0.5em 0;\n\t}\n\n\t.sidebar-submenu:hover:first-child {\n\t\tborder-radius: 0 0.5em 0 0;\n\t}\n\n\t.sidebar-submenu:hover:last-child {\n\t\tborder-radius: 0 0 0.5em 0;\n\t}\n\n\t.menu-on-hover:hover {\n\t\tposition: relative;\n\t}\n\n\t.menu-on-hover:hover > .sidebar-submenu-container {\n\t\tdisplay: block;\n\t\tposition: fixed;\n\t\tz-index: 20;\n\t\toverflow: scroll;\n\t\tmargin-inline: 0;\n\t\twidth: 11em;\n\t\tborder-radius: 0 0.5em 0.5em 0;\n\t\tbackground-color: $dark-red;\n\n\t\t& > a {\n\t\t\tpadding: 0;\n\t\t}\n\t}\n\n\t.menu-on-hover:hover > #content {\n\t\tleft: 4em;\n\t\ttop: 11.5em;\n\t}\n\n\t.menu-on-hover:hover > #products {\n\t\tleft: 4em;\n\t\ttop: 15em;\n\t}\n\n\t.menu-on-hover:hover > #members {\n\t\tleft: 4em;\n\t\ttop: 18em;\n\t}\n\n}\n\n::-webkit-scrollbar {\n\twidth: 0px;\n}\n\n.sidebar-selected {\n\tbackground-color: $sidebar-selected-color;\n}","@mixin flex($justify-content, $align-items) {\n\tdisplay: flex;\n\tjustify-content: $justify-content;\n\talign-items: $align-items;\n}\n\n@mixin flexColumn($justify-content, $align-items) {\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: $justify-content;\n\talign-items: $align-items;\n}\n","$dark-red: #8f003c;\n$sidebar-selected-color: #c4145d;\n$sidebar-logo-color: #a53363;\n$logo-color: #920942;\n$white: #fff;\n$grey: #f3f6f9;\n$grey2: #e2e5e7;\n$dark-grey: #777776;\n$font-color: #fff;\n$shadow-color: #4e7da2;\n$font: 'Rubik';\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
